import { Component, Inject, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { api } from '@src/constants/api';
import { RegexpCheckerDialogData } from './regexp-checker-dialog.data';
//
const htmlEscapes = {
    '&': '&amp',
    '<': '&lt',
    '>': '&gt',
    '"': '&quot',
    "'": '&#39'
};

@Component({
    selector: 'regexp-checker-dialog',
    template: require('./regexp-checker-dialog.component.html'),
    styles: [require('./regexp-checker-dialog.component.scss')]
})
export class RegexpCheckerDialogComponent implements OnDestroy {
    @ViewChild('textarea') public textarea: ElementRef;
    @ViewChild('backdrop') public backdrop: ElementRef;

    public findWordNumber = 0;
    public expression = '';
    public matches = [];
    public text = '';
    public prevText = '';
    public caseSensitive: boolean;

    public modelChanged = new Subject();

    constructor(
        private dialogRef: MatDialogRef<RegexpCheckerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: RegexpCheckerDialogData,
        @Inject('$http') private $http: any) {
        this.expression = data.expression;
        this.caseSensitive = data.caseSensitive;
        this.modelChanged.pipe(debounceTime(500)).subscribe(async () => await this.checkText());
    }

    public ngOnDestroy() {
        this.modelChanged.complete();
    }

    public inputText() {
        const highlight = this.backdrop.nativeElement.firstElementChild;
        let html = this.text.replace(/[&<>"']/g, chr => htmlEscapes[chr]);
        //check which word was highlight until now and add 13 to the index, 13 because of <mark></mark> is 13 letters
        this.findWordNumber = 0;
        for (const match of this.matches) {
            const matchString = html.substring(0, match.index + 13 * this.findWordNumber) + "<mark>" + html.substring(match.index + 13 * this.findWordNumber, match.index + match.length + 13 * this.findWordNumber) + "</mark>" + html.substring(match.index + match.length + (13 * this.findWordNumber));
            html = matchString;
            this.findWordNumber++;
        }
        setTimeout(() => { highlight.innerHTML = html; });
    }

    public scrollText() {
        this.backdrop.nativeElement.scrollTop = this.textarea.nativeElement.scrollTop;
    }

    public save() {
        this.dialogRef.close({ expression: this.expression, caseSensitive: this.caseSensitive });
    }

    private async checkText() {
        if (this.expression && this.text) {
            const requestBody = {
                ignoreCase: !this.caseSensitive,
                multiline: false,
                input: this.text,
                pattern: this.expression
            };
            try {
                const response = await this.$http.post(`${api.restServiceUrl}Policies/Regex`, requestBody);
                this.matches = response.data.Matches || [];
                this.prevText = this.text;
            } catch (error) {
                console.error('Regex validation failed:', error);
                this.matches = [];
            }
        } else if (!this.expression || !this.text) {
            this.matches = [];
        }
        this.inputText();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/regexp-checker-dialog/regexp-checker-dialog.component.ts